import $ from 'jquery';

export default function slickExtend() {
  // add href around right side image
  window.onload = (event) => {
    let img = $('.slides-container img');
    img.each(function (key, el) {
      let 
        cont = $(el).parents('.slides-container'),
        link = $('a', cont).attr('href');

      $(el).wrap(function () {
        return "<a href='" + link + "'><img src='" + el.src + "' width='" + el.width + "' height='" + el.height + "' alt='" + el.alt + ">'</a>";
      });
    });
  };

  // slide counter
  $('.slick').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    let 
      current = nextSlide + 1,
      readout = $("[name='slide-counter-current']",this);
    readout.val(current);
  });
}